export function metadataRequest() {
  return {
    type: '@metadata/REQUEST',
  };
}

export function metadataSuccess(information) {
  return {
    type: '@metadata/SUCCESS',
    payload: { ...information },
  };
}

export function metadataFailure() {
  return {
    type: '@metadata/FAILURE',
  };
}
